import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useFetch, usePromise, useRouting } from '@rad/hooks';
import { getOrgStory } from '../../common/network/org-story';
import { landingRoutes, orgRoutes } from '../../common/routes';
import E404 from '../system/no-layout-404';
import Loading from './components/property/loading';
import OrgStoryLoader from './components/property/org-story-loader';
// Loads the view by id; a URL with the wrong subdomain is sent to the permanent address.
const OrgStoryScreen = (props) => {
    const [storyP] = useFetch(getOrgStory(props.id));
    const story = usePromise(storyP);
    const [, navigate] = useRouting();
    useEffect(() => {
        if (story && story.community.subdomain && story.community.subdomain !== props.org) {
            // Replaces the entry so Back does not land on the stale subdomain and redirect forward again.
            navigate(orgRoutes.story.getURL({ 'org': story.community.subdomain, 'id': story.id }), { 'replace': true });
        }
    }, [story, props.org, navigate]);
    if (story === undefined)
        return _jsx(Loading, {});
    if (story === null)
        return _jsx(E404, { urlHome: landingRoutes.root.getURL() });
    return _jsx(OrgStoryLoader, { story: story });
};
export default OrgStoryScreen;
